import { render, staticRenderFns } from "./ItemListRealBuyLayout.vue?vue&type=template&id=5b4a94ee&scoped=true"
import script from "./ItemListRealBuyLayout.vue?vue&type=script&lang=js"
export * from "./ItemListRealBuyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4a94ee",
  null
  
)

export default component.exports